

var globalizacao = {

    mensagens: null,

    detectaLingua: function () {
        var l = window.navigator.language || window.navigator.userLanguage || "en-US";
        console.log(l);
        var temp = l.split("-");
        if (temp.length > 1) {
            l = temp[0].toLowerCase() + "-" + temp[1].toUpperCase();
        }
        return l;
    },

    linguaDoUsuario: "pt-BR",

    validaMsgs: function () {
        //para cada lingua
        for (var lingua in this.mensagens) {
            //percorre todas as outras
            for (var linguaOutra in this.mensagens) {
                //mesmas entao vai pra proxima
                if (lingua === linguaOutra) {
                    continue;
                }
                //compara todas msgs com a outra
                for (var msg in this.mensagens[lingua]) {
                    if (!this.mensagens[linguaOutra].hasOwnProperty(msg)) {
                        throw new Error("lingua: " + linguaOutra + " não possui msg:" + msg +
                            ", que a lingua:" + lingua + " possui");
                    }
                }
            }
        }
        return this;
    },

    getLinguaDoUsuario: function () {
        return this.linguaDoUsuario ||
            this.getLinguaDoUsuarioComPadrao("en-US");
    },

    getLinguaPadronizada: function () {
        return this.getLinguaCodeName();
    },


    getLinguaCodeName: function (padrao) {
        var lang = this.detectaLingua();
        var l = lang.toLowerCase();
        if (l == "es" || l.indexOf("es-") >= 0) {
            return "es";
        }
        if (l == "en" || l.indexOf("en-") >= 0) {
            return "en-US";
        }
        if (l == "pt" || l.indexOf("pt-") >= 0 || l === "ptbr") {
            return "pt-BR";
        }
        if (padrao) {
            return padrao;
        }
        return lang;
    },

    getLinguaDoUsuarioComPadrao: function (padraoSeNaoTiverLingua) {
        var l = this.getLinguaPadronizada();
        if (!this.mensagens.hasOwnProperty(l)) {
            l = padraoSeNaoTiverLingua;
            if (!this.mensagens.hasOwnProperty(l)) {
                l = "en-US";
            }
        }
        return l;
    },

    setLinguaDoUsuario: function (l) {
        if (!this.mensagens.hasOwnProperty(l)) {
            console.error("Não existe esta lingua");
            l = "en-US";
        }
        this.linguaDoUsuario = l;
        window.localStorage.setItem("lingua-app", this.linguaDoUsuario);
    },

    traduzirTexto: function (texto) {
        return texto.replace(/{@(\w+)}/gim, function (parametroCompleto, parametro) {
            return globalizacao.msg(parametro);
        });
    },
    /*
     globalizacao.msg("gameOver",{
                           "score" : this.score
                       });
    */
    msg: function (idMsg, parametros) {
        var msg = this.mensagens[this.linguaDoUsuario][idMsg];
        if (typeof msg === "undefined") {
            throw new Error("Não existe mensagem de id: " + idMsg);
        }
        if (parametros) {
            var _p = {};
            //faz o replace e ja valida  se os parametros estao sendo enviados corretamente
            msg = msg.replace(/{@(\w+)}/gim, function (parametroCompleto, parametro) {
                if (!parametros.hasOwnProperty(parametro)) {
                    throw new Error("Não foi informado o parametro '" + parametro +
                        "' na msg id: " + idMsg);
                }
                _p[parametro] = parametros[parametro];
                return parametros[parametro];
            });
            for (var p in parametros) {
                if (!_p.hasOwnProperty(p)) {
                    throw new Error("Não existe parametro '" + p + "' na msg id: " + idMsg);
                }
            }
        }
        return msg;
    },

    init: function (traducoes) {
        this.mensagens = traducoes;
        //mapeia as  linguas equivalentes
        //globalizacao.mensagens["pt"] = globalizacao.mensagens["pt-BR"];
        //globalizacao.mensagens["en"] = globalizacao.mensagens["en-US"];

        globalizacao.setLinguaDoUsuario(
            //window.localStorage.getItem("lingua-app") ||
            globalizacao.getLinguaDoUsuarioComPadrao("en-US")
        );
        return this;
    }
};

globalizacao.validaMsgs();


export default globalizacao;








// WEBPACK FOOTER //
// ./src/js/escolha/globalizacao/globalizacao.js